import { gql } from "@apollo/client";

export const UPDATE_SINGLE_ACCOUNT = gql`
  mutation (
    $id: Int!
    $firstName: String!
    $lastName: String!
    $contactPhoneNumber: String!
    $activityPhoneNumber: String!
    $timeZone: String!
    $summary: String
    $specialistId: Int!
    $bdlProgramStartOn: String
    $bdlProgramEndOn: String
    $leadType: String
    $Id_Ehr: String!
  ) {
    updateAccount(
      data: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        contactPhoneNumber: $contactPhoneNumber
        activityPhoneNumber: $activityPhoneNumber
        timeZone: $timeZone
        summary: $summary
        specialistId: $specialistId
        bdlProgramStartOn: $bdlProgramStartOn
        bdlProgramEndOn: $bdlProgramEndOn
        leadType: $leadType
        Id_Ehr: $Id_Ehr
      }
    ) {
      id
      firstName
      lastName
      contactPhoneNumber
      activityPhoneNumber
      specialist {
        id
        firstName
        lastName
      }
      timeZone
      summary
      leadType
      Id_Ehr
    }
  }
`;

export const QUERY_RESPONSE = gql`
  query {
    specialists {
      id
      firstName
    }
  }
`;

export const UPDATE_SINGLE_USER = gql`
  mutation ($firstName: String!, $lastName: String!, $userId: Int!, $isTestUser: Boolean!) {
    updateUser(data: { id: $userId, firstName: $firstName, lastName: $lastName, isTestUser: $isTestUser }) {
      id
      firstName
      lastName
      email
      isTestUser
    }
  }
`;
